// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"571":"680f299f","766":"61b1d21b"}[chunkId] + ".chunk.css";
};